export default __webpack_public_path__ + "static/media/gasolinera.32ed20ec.png";